<script setup lang="ts">
import { ref } from "vue";
import ProfessionalBodies
  from "@/domains/home/services/configurations/views/settings/insolvency/proffessionalBodies/ProfessionalBodies.vue";
import AcademicQualifications
  from "@/domains/home/services/configurations/views/settings/insolvency/academicQualifications/AcademicQualifications.vue";
import ProfessionalQualifications
  from "@/domains/home/services/configurations/views/settings/insolvency/professionalQualifications/ProfessionalQualifications.vue";
import WindingUpReasons
  from "@/domains/home/services/configurations/views/settings/insolvency/reasons/WindingUpReasons.vue";
import AllInsolvencySubmissions
  from "@/domains/home/services/configurations/views/settings/insolvency/AllInsolvencySubmissions.vue";

const currentRoute = ref<string>('submissions')

const select = (route: string) => {
  currentRoute.value = route
}
</script>

<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-2">
        <div
            :class="[(currentRoute === 'academic') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('academic')">
          <div class="flex">
            <div>Academic Qualifications Manuals</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'bodies') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('bodies')"
        >
          <div class="flex">
            <div>Professional Bodies</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'professional') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('professional')"
        >
          <div class="flex">
            <div>Professional Qualifications</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'reasons') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('reasons')"
        >
          <div class="flex">
            <div>Winding Up Reasons</div>
          </div>
        </div>
        <div
            :class="[(currentRoute === 'submissions') ? 'menu-pill-active' : 'menu-pill']"
            @click="select('submissions')">
          <div class="flex">
            <div>Insolvency Applications</div>
          </div>
        </div>
      </div>
      <div class="col-span-10">
        <ProfessionalBodies v-if="currentRoute === 'bodies'"/>
        <AcademicQualifications v-if="currentRoute === 'academic'"/>
        <ProfessionalQualifications v-if="currentRoute === 'professional'"/>
        <WindingUpReasons v-if="currentRoute === 'reasons'"/>
        <AllInsolvencySubmissions v-if="currentRoute === 'submissions'"/>
      </div>
    </div>
  </div>
</template>
